const FACE_BASE_API = process.env.REACT_APP_FACE_API;
const AUTH_BASE_API = process.env.REACT_APP_AUTH_API;
const CUSTOMER_BASE_API = process.env.REACT_APP_CUSTOMER_API;
const OCR_BASE_API = process.env.REACT_APP_OCR_API;
const CSV_BASE_API = process.env.REACT_APP_CSV_API;
const BUSINESS_CUSTOMER_BASE_API = process.env.REACT_APP_BUSINESS_CUSTOMER_API;
const DOCUMENT_BASE_API = process.env.REACT_APP_DOCUMENT_API;
const CONTRACT_BASE_API = process.env.REACT_APP_CONTRACT_API;
const SHOPPING_CART_BASE_ORDERS_API = process.env.REACT_APP_SHOPPING_CART_ORDERS_API;
const DEVICE_BASE_API = process.env.REACT_APP_DEVICE_API;

export default {
    FACE_BASE_API: `${FACE_BASE_API}`,
    AUTH_BASE_API: `${AUTH_BASE_API}`,
    CUSTOMER_BASE_API: `${CUSTOMER_BASE_API}`,
    OCR_BASE_API: `${OCR_BASE_API}`,
    CSV_BASE_API: `${CSV_BASE_API}`,
    BUSINESS_CUSTOMER_BASE_API: `${BUSINESS_CUSTOMER_BASE_API}`,
    DOCUMENT_BASE_API: `${DOCUMENT_BASE_API}`,
    CONTRACT_BASE_API: `${CONTRACT_BASE_API}`,
    SHOPPING_CART_BASE_ORDERS_API: `${SHOPPING_CART_BASE_ORDERS_API}`,
    DEVICE_BASE_API: `${DEVICE_BASE_API}`,

    // FACE Service Routes
    face: `${FACE_BASE_API}/face`,
    faceDetection: `${FACE_BASE_API}/Face/detect`,
    faceGroup: `${FACE_BASE_API}/Face/group`,
    existingPerson(personId) {
        return `${FACE_BASE_API}/Face/${personId}/existing`;
    },
    faceTrain: `${FACE_BASE_API}/Face/train`,
    trainingStatus(group) {
        return `${FACE_BASE_API}/Face/training/${group}/status`;
    },
    faceVerify: `${FACE_BASE_API}/Face/verify`,
    faceIdentify: `${FACE_BASE_API}/Face/identify`,

    // AUTH Service Routes
    register: `${AUTH_BASE_API}/users/register`,
    login: `${AUTH_BASE_API}/users/authenticate`,
    authUser(id) {
        return `${AUTH_BASE_API}/users/${id}`;
    },

    // CUSTOMER Service Routes
    customers: `${CUSTOMER_BASE_API}/customers`, // Used in GET and POST
    getCustomer(customer_id) { // Used in GET AND DELETE
        return `${CUSTOMER_BASE_API}/customers/${customer_id}`;
    },
    accountHolder(customer_id, account_holder_id) { // Used in GET, DELETE and PUT
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/accountholder/${account_holder_id}`;
    },
    createAccountHolder(customer_id) { // Used in POST
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/accountholder`;
    },
    getAddressId(customer_id) { // Used in GET and DELETE
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/addresses`;
    },
    address(customer_id, address_id) { // Used in GET, POST and PUT
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/addresses/${address_id}`;
    },
    createContactInfo(customer_id) { // Used in POST
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/contactinfo`;
    },
    contactInfo(customer_id, contact_info_id) { // Used in GET, PUT and DELETE
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/contactinfo/${contact_info_id}`;
    },
    createReference(customer_id) { // Used in POST and GET
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/references`;
    },
    reference(customer_id, reference_id) {
        return `${CUSTOMER_BASE_API}/customers/${customer_id}/references/${reference_id}`;
    },

    // OCR Routes
    scanId: `${OCR_BASE_API}/Scan`,

    // CSV routes
    uploadCsv: `${CSV_BASE_API}/csv/upload`, // used in POST

    // Business Customer Service Routes

    company(company_id) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${company_id}`; // used in GET, DELETE and PUT
    },

    companies: `${BUSINESS_CUSTOMER_BASE_API}/api/companies`, // used in POST and GET

    allBusinessCustomers: `${BUSINESS_CUSTOMER_BASE_API}/customers`,

    businessCustomers(companyId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers`; // used in POST and GET
    },
    businessCustomersBulk(companyId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/bulk`; // used in POST and GET
    },
    businessCustomer(companyId, customerId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}`; // used in GET, DELETE and PUT
    },
    businessCustomerExists(bamId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/bam/${bamId}/exists`; // used in POST and GET
    },
    businessCustomerAllContracts() {
        return `${BUSINESS_CUSTOMER_BASE_API}/contracts`;
    },
    businessCustomerCompanyContracts(companyId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/contracts`;
    },
    businessCustomerCustomerContracts(companyId, customerId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/contracts`; // used in GET, POST
    },
    businessCustomerRepresentativeContracts(companyId, customerId, repId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts`; // used in GET, POST
    },
    businessCustomerCustomerContract(companyId, customerId, repId, contractId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts/${contractId}`; // used in GET, PUT
    },
    businessCustomerCustomerCreateCommitment(companyId, customerId, repId, contractId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts/${contractId}/commitment`; // used in POST
    },
    businessCustomerCustomerUpdateCommitment(companyId, customerId, repId, contractId, commitmentLetterId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts/${contractId}/commitment/${commitmentLetterId}`; // used in PUT
    },
    businessCustomerCustomerCreatePromissory(companyId, customerId, repId, contractId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts/${contractId}/promissory`; // used in POST
    },
    businessCustomerCustomerUpdatePromissory(companyId, customerId, repId, contractId, commitmentLetterId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/contracts/${contractId}/promissory/${commitmentLetterId}`; // used in PUT
    },
    businessCustomerPolicies() {
        return `${BUSINESS_CUSTOMER_BASE_API}/policies`;
    },
    businessCustomerCompanyPolicies(companyId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/policies`;
    },
    businessCustomerCustomerPolicies(companyId, customerId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/policies`; // used in GET, POST
    },
    businessCustomerRepresentativePolicies(companyId, customerId, repId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/policies`; // used in GET, POST
    },
    businessCustomerCustomerPolicy(companyId, customerId, repId, contractId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representative/${repId}/policies/${contractId}`; // used in GET, PUT
    },

    representatives() {
        return `${BUSINESS_CUSTOMER_BASE_API}/representatives`;
    },
    representativeExists(REP_ID) {
        return `${BUSINESS_CUSTOMER_BASE_API}/representatives/${REP_ID}/exists`; // used in GET
    },
    companyRepresentatives(companyId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/representatives`;
    },
    customerRepresentatives(companyId, customerId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representatives`;
    },
    representative(companyId, customerId, repId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representatives/${repId}`;
    },
    primaryRepresentative(companyId, customerId, repId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/representatives/${repId}/primary`;
    },
    customerDocuments(companyId, customerId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/documents`;
    },
    customerDocument(companyId, customerId, documentId) {
        return `${BUSINESS_CUSTOMER_BASE_API}/companies/${companyId}/customers/${customerId}/documents/${documentId}`;
    },

    // DOCUMENT MANAGEMENT SERVICE ROUTES
    documents: `${DOCUMENT_BASE_API}/documents`,
    getDocument(document_id) {
        return `${DOCUMENT_BASE_API}/documents/${document_id}`;
    },
    getDocumentData(document_id) {
        return `${DOCUMENT_BASE_API}/documents/${document_id}/data`;
    },
    getDocumentDownload(document_id) {
        return `${DOCUMENT_BASE_API}/documents/${document_id}/download`;
    },

    // CONTRACT Service Routes
    contract: `${CONTRACT_BASE_API}/contract`,
    contractView: `${CONTRACT_BASE_API}/contract/view`,

    // SHOPPING CART Service Routes
    orders: `${SHOPPING_CART_BASE_ORDERS_API}`,
    order(orderId) {
        return `${SHOPPING_CART_BASE_ORDERS_API}/${orderId}`;
    },

    // DEVICE Service Routes
    catalog: `${DEVICE_BASE_API}/devices/catalog`,
    catalogPricing: `${DEVICE_BASE_API}/devices/pricing`,
    catalogDeviceDetails: `${DEVICE_BASE_API}/devices/details`,
    catalogDeviceInfo: invoiceId => `${DEVICE_BASE_API}/devices/invoices/id/${invoiceId}/info`,
    invoiceNumber: invoiceNumber => `${DEVICE_BASE_API}/devices/invoices/number/${invoiceNumber}`,
    priceTiers: `${DEVICE_BASE_API}/devices/tiers`
};
